<template>
    <div class="DashboardStepGroupRepetitionNotification --global-clickable" @click="gotoStepGroupQuizIntro()">
        <div class="text">
            {{ $t('text') }}
            <span class="courseName">{{ $t(`dashboard.general.lifeskillLabels.${course.lifeskillNumber}`) }}</span>
        </div>
        <div v-if="image" class="image" />
        <div v-if="time" class="time">
            {{ time }}
        </div>
    </div>
</template>

<translations>
  text: 'You have a new repetition in'
  text_no: 'Du har en ny repetisjon i'
</translations>

<script>
export default {
    props: {
        image: String,
        time: String,
        stepGroupId: {
            type: String,
            required: true
        }
    },
    computed: {
        stepGroup() {
            return this.$store.state.moduleCourse.stepGroups[this.stepGroupId];
        },
        course() {
            return this.$store.state.moduleCourse.courses[this.stepGroup.courseId];
        }
    },
    methods: {
        gotoStepGroupQuizIntro() {
            this.$emit('action');
            const stepGroup = this.$store.state.moduleCourse.stepGroups[this.stepGroupId];
            this.$router.push({
                name: 'StepGroupQuizIntroView',
                params: { courseId: stepGroup.courseId, stepGroupId: this.stepGroupId }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardStepGroupRepetitionNotification {
    padding: 1em;
    color: rgba(black, 0.5);
}
.image {
    width: 5em;
    height: 4em;
    background-color: gray;
    margin-top: 0.5em;
}
.text {
    line-height: 1.5em;
}
.time {
    color: rgba(black, 0.5);
    margin-top: 0.5em;
}
.courseName {
    color: rgba(black, 0.8);
}
</style>
